import { ActivatedRouteSnapshot } from '@angular/router';
import { WcgTableValues } from '@shared/interfaces/wcg-table-utils.interface';
import { DEFAULT_PAGE_SIZE } from './grid.constants';

export const CONFIGURE_DEFAULT_PARAMS = (
  route?: ActivatedRouteSnapshot,
): WcgTableValues => {
  return {
    filters: route?.queryParams['filters'] ?? '',
    page: route?.queryParams['pageIndex'] ?? 1,
    pageSize: route?.queryParams['pageSize'] ?? DEFAULT_PAGE_SIZE,
    searchValue: route?.queryParams['searchValue'] ?? '',
    sortParam: route?.queryParams['sortParam'] ?? '',
  };
};
